<template>
  <div class="input-scatterplot">
      <div style="margin-bottom: 10px; padding: 10px; background: #ebebeb">
        Render scatterplots with pearson correlations calculated for two genes and their different data types. 
      </div>
    <v-app class="input-scatterplot-tabs">
      <v-card-title>Select on X-axis</v-card-title>
      <v-card flat>
        
      <v-tabs
        v-model="tabX"
      >
          <v-tab href="#tab-1">
            Select<br>gene(s)
          </v-tab>
          <v-tab href="#tab-2">
            Select<br>cell type(s)
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tabX">

          <v-card style="margin-top: 20px;">

            <v-tab-item value="tab-1">
            <div>
                   <v-autocomplete
        v-model="scatterplotGeneA"
        :items="genes"
        outlined
        :menu-props="{closeOnContentClick: true}"
        dense
        :label="`Select gene on X-axis`"
        clearable
    >
    </v-autocomplete>
    
  </div>
            </v-tab-item>
                        <v-tab-item value="tab-2">
            <div>
        <v-autocomplete
        v-model="scatterplotCelltypeA"
        :items="celltype"
        outlined
        :menu-props="{closeOnContentClick: true}"
        dense
        :label="`Select cell type on X-axis`"
        clearable
    >
    </v-autocomplete>
  </div>
           
    <!-- <input-boxplot-customize /> -->
            </v-tab-item>

            <!-- <v-tab-item value="tab-3">
              3
            </v-tab-item> -->

          </v-card>

        </v-tabs-items>
      </v-card>
         <!-- <p>Checked: {{ cohortSelected }}</p> -->
    <!-- </v-app> 
    <v-app class="input-scatterplot-tabs"> -->
      <v-card-title>Select on Y-axis</v-card-title>
      <v-card flat>
      <v-tabs
        v-model="tabY"
      >
          <v-tab href="#tab-1">
            Select<br>gene(s)
          </v-tab>
          <v-tab href="#tab-2">
            Select<br>cell type(s)
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tabY">

          <v-card style="margin-top: 20px;">

            <v-tab-item value="tab-1">
            <div>
                   <v-autocomplete
        v-model="scatterplotGeneB"
        :items="genes"
        outlined
        :menu-props="{closeOnContentClick: true}"
        dense
        :label="`Select gene on Y-axis`"
        clearable
    >
    </v-autocomplete>
    
  </div>
            </v-tab-item>
                        <v-tab-item value="tab-2">
            <div>
        <v-autocomplete
        v-model="scatterplotCelltypeB"
        :items="celltype"
        outlined
        :menu-props="{closeOnContentClick: true}"
        dense
        :label="`Select cell type on Y-axis`"
        clearable
    >
    </v-autocomplete>

  </div>
           
    <!-- <input-boxplot-customize /> -->
            </v-tab-item>

            <!-- <v-tab-item value="tab-3">
              3
            </v-tab-item> -->

          </v-card>

        </v-tabs-items>
        <div class="button-container">
          <v-btn 
      :disabled="!valid"
      elevation="2"
      small
      color="blue lighten-2"
      dark
      
      @click="setScatterplotTracks"
    > 
      Submit gene(s)/celltype(s)
    </v-btn>
    </div>
      </v-card>
    <div class="cohort-selector" v-if="twoCohorts()">
      <input type="checkbox" id="discovery" value="discovery" v-model="cohortSelected" />
      <label for="discovery">&nbsp;Discovery cohort</label>
      <br>
      <input type="checkbox" id="validation" value="validation" v-model="cohortSelected" />
      <label for="validation">&nbsp;Validation cohort</label>
    </div>
        <input-scatterplot-customize 
    :studySelected="this.studySelected"
    :cellTypesX="this.cellTypesX"
    :cellTypesY="this.cellTypesY"
    />
    
       <!-- <p>Checked: {{ cohortSelected }}</p> -->
    </v-app> 
      
      <!-- <v-autocomplete
        v-model="scatterplotGeneB"
        :items="genes"
        outlined
        :menu-props="{closeOnContentClick: true}"
        dense
        :label="`Select gene on Y-axis`"
        clearable
    >
    </v-autocomplete> -->




  </div>
</template>

<script>
import InputScatterplotCustomize from './InputScatterplotCustomize.vue'
import cellTypes from '../../refs/cellTypes';

export default {
    components: { InputScatterplotCustomize  },
    
    name: "input-scatterplot",
    props: ['studySelected'],

    computed: {
        available() {
          if (this.studySelected === 'PCC') {
            return this.$store.state.availableGenes['PCC']
          } else {
            return this.$store.state.availableGenes['PTRC']
          }
        },
        // loaderBoxplot() { return this.$store.state.loaderBoxplot },
        genes() { 
            const available = Object.keys(this.available)
            available.sort()
            return available
        },
        valid() { return (this.scatterplotGeneA.length > 0 || this.scatterplotCelltypeA.length > 0) && ( this.scatterplotGeneB.length > 0 || this.scatterplotCelltypeB.length > 0)},
        tabX: {
          get() { return this.$store.state.Scatterplot_tabX },
          set(tab) { this.$store.dispatch('setViewAttr', 
                    { view: 'Scatterplot', 
                      attrKey: 'tabX', 
                      attrVal: tab }) },
        },
        tabY: {
          get() { return this.$store.state.Scatterplot_tabY },
          set(tab) { this.$store.dispatch('setViewAttr', 
                    { view: 'Scatterplot', 
                      attrKey: 'tabY', 
                      attrVal: tab }) },
        },
        celltype() {
          console.log('celltype', cellTypes[this.studySelected])
          var celltype_ = cellTypes[this.studySelected]
          return celltype_
        },
        cohortSelected: {
          get() { return this.$store.state.Scatterplot_cohortSelected },
          set(v) { 
            // console.log
            this.$store.dispatch(
              'setViewAttr', { 
                view: 'Scatterplot',
                attrKey: 'cohortSelected',
                attrVal: v 
              }
            )}
        },
      },

    
    data: () => ({
        loading: false,
        scatterplotGeneA: '',
        scatterplotGeneB: '',
        scatterplotCelltypeA: '',
        scatterplotCelltypeB: '',
        cellTypesX: false,
        cellTypesY: false,
        // cohortSelected: ['discovery', 'validation'],
        dataTypes: ['CNV', 'Proteo', 'RNA', 
              // 'CellType', 
                      'Kinase', 'TranscriptionFactor', 'ubiq', 'glyco', 'phospho']
    }),
    watch: {
      available() {
        // genes() { 
        console.log('watch available boxplot', this.available, this.studySelected)
            const available = Object.keys(this.available)
            available.sort()
            this.genes = available
        // },
      },
      studySelected() {
        this.submitScatterplotGenes()
      },
      tabX(){
        if (this.tabX === 'tab-2') {
          this.cellTypesX = true
        } else {
          this.cellTypesX = false
        }
        this.submitScatterplotGenes()
      },
      tabY(){
        if (this.tabX === 'tab-2') {
          this.cellTypesY = true
        } else {
          this.cellTypesY = false
        }
        this.submitScatterplotGenes()
      }
    },

    methods: {
      twoCohorts() {
          return this.studySelected === 'PTRC'
      },
        submitScatterplotGenes() {
            this.$store.dispatch('getTracks', 
            { 
              view: 'Scatterplot', 
              genes: [this.scatterplotGeneA, this.scatterplotGeneB ],
              combine_bool: true
            }
          )
        },
        setScatterplotTracks() {
          // console.log()
          console.log('testscatter1', [this.scatterplotGeneA, this.scatterplotGeneB])
          var x_axis_dataname = this.cellTypesX ? this.scatterplotCelltypeA : this.scatterplotGeneA
          var y_axis_dataname = this.cellTypesY ? this.scatterplotCelltypeB : this.scatterplotGeneB

          this.$store.dispatch('getTracks', {
            view: 'Scatterplot',
            genes: [x_axis_dataname, y_axis_dataname],
            combine_bool: true,
            studySelected: this.studySelected
          })
          console.log('testscatter1', this.$store.state.Scatterplot_data)
            // this.setScatterplotTracks()
          // this.$store.dispatch('setScatterplotTracks', {
          //   Scatterplot_tracks: [ this.scatterplotXdata, this.scatterplotYdata ] 
          // })
          // this.$store.dispatch('setScatterplotDT', {
          //   Scatterplot_datatypes: [ this.scatterXDatatype, this.scatterYDatatype]
          // })
          console.log('datatypes:', 
                  this.$store.state.Scatterplot_dataX_DT, 
                  this.$store.state.Scatterplot_dataY_DT)
        },
    },

}
</script>

<style>
.input-scatterplot {
    margin: 10px;
}

.input-scatterplot-tabs{
  margin: 10px;
  height: 400px;
  /* display: flex;
  flex-wrap: nowrap; */
}

.cohort-selector {
    margin: 10px;
    overflow: hidden;
}

.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}

/* CSS/Style Block */
.button-container {
  display: flex;
  flex-direction: column; /* Stacks vertically */
  gap: 20px;              /* Adds 20px of space between children */
}

@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

.ttest-descriptor {
  width: 100%;
  margin: 10px;
  font-size: 0.8em;
}
</style>